import { render, staticRenderFns } from "./GroupsFilter.vue?vue&type=template&id=a86c5904&"
import script from "./GroupsFilter.vue?vue&type=script&lang=js&"
export * from "./GroupsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports